// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"C5-z"};